import React from "react";
import TechAreaSearch from "./TechAreaSearch";
import TechAreaList from "./TechAreaList";
import { useState, useEffect } from "react";
import { TechAreaService } from "../../../services/TechAreaService";
import CreateOrEdit from "./CreateOrEdit";
import { func } from "prop-types";
import TechAreaDelete from "./TecchAreaDelete";
import Pagination from "../../../components/Pagination";

export default function TechAreaPage() {
  const [searchObject, setSearchObject] = useState({});
  const [list, setList] = useState([]);
  const [techAreaId, setTechAreaId] = useState();
  const [techArea, setTechArea] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const pageSize = 20;
  const [totalPages, setTotalPages] = useState(0);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isOpenCreatOrEdit, setIsOPenCreatOrEdit] = useState(false);
  useEffect(() => {
    getTechAreas();
  }, [searchObject, pageNumber]);

  function onCloseCreateOrEdit() {
    setIsOPenCreatOrEdit(false);
    getTechAreas();
  }
  function setCreateOrEdit(id) {
    setIsOPenCreatOrEdit(true);
    setTechAreaId(id);
  }
  function getTechAreas() {
    TechAreaService.getAll(pageSize, pageNumber, searchObject.description).then(
      (data) => {
        setList(data.page);

        setTotalPages(Math.ceil(data.total / pageSize));
      }
    );
  }
  function onCloseDelete() {
    setIsDeleteOpen(false);
    setTechArea({});
    getTechAreas();
  }
  function setTechAreaForDelete(techArea) {
    setTechArea(techArea);
    setIsDeleteOpen(true);
  }

  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }
  return (
    <>
      <div className="row">
        <div className="col">
          {" "}
          <TechAreaSearch searchObject={searchObject} onChange={onChange} />
        </div>
        <div className="col text-end">
          <button
            className="app-button btn-prime btn-md"
            onClick={() => setIsOPenCreatOrEdit(true)}
          >
            <i class="bi bi-plus-lg"></i>
          </button>
        </div>
      </div>

      <TechAreaList
        searchObject={searchObject}
        setSearchObject={setSearchObject}
        setCreateOrEdit={setCreateOrEdit}
        list={list}
        setForDelete={setTechAreaForDelete}
      />
      <Pagination
        totalPages={totalPages}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
      />
      <CreateOrEdit
        isOpen={isOpenCreatOrEdit}
        onClose={onCloseCreateOrEdit}
        techAreaId={techAreaId}
      />
      <TechAreaDelete
        techArea={techArea}
        onClose={onCloseDelete}
        isOpen={isDeleteOpen}
      />
    </>
  );
}
